module.exports = __webpack_public_path__ + "static/media/user.2b2b0f91.svg";